import { forwardRef, useRef } from 'react';
import AntDraggableModal from '../../universal/AntDraggableModal';
import { BaseWebUniversalProps } from '../system/BaseWebUniversal';
import BaseFiles, { BaseFilesProps } from './BaseFiles';
import { useMergedRef } from '../hooks/general';
import { CommonProps } from '../../../utilsTs/declareTypes';

/** 属性 */
export interface FilesSelectorProps extends Pick<BaseWebUniversalProps, 'titleName' | 'defaultService' | 'sendPageData'>,
    Pick<BaseFilesProps, 'insertFile' | 'defaultSelectedOptions' | 'selectMode'>,
    Pick<CommonProps, 'closeModal' | 'visible'> {
};

/**
 * 文件选择器
 * @param props 属性
 * @returns 
 */
const FilesSelector = forwardRef<any, FilesSelectorProps>((props, ref) => {
    const internalRef = useRef<any>(undefined);
    /** 合并外部 ref 和内部 refLocal */
    const mergedRef = useMergedRef(internalRef, ref);
    const { titleName, visible = true, selectMode, closeModal, defaultService, sendPageData, insertFile, defaultSelectedOptions } = props;
    const currentProps: BaseFilesProps = {
        selectMode,
        displayOptions: { viewMode: 'gallery' },
        defaultService,
        sendPageData,
        closeModal,
        insertFile,
        defaultSelectedOptions
    }
    return (
        <>
            <AntDraggableModal
                title={titleName}
                open={visible}
                okText='关闭'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={() => closeModal?.()}
                closable={false}
                maskClosable={false}
                width={1280}
            >
                <BaseFiles {...currentProps} ref={mergedRef} />
            </AntDraggableModal>
        </>
    )
});

export default FilesSelector;